__turbopack_context__.v({
  "activeItem": "brands-module-scss-module__1xzv-W__activeItem",
  "allBrandPage": "brands-module-scss-module__1xzv-W__allBrandPage",
  "brandList": "brands-module-scss-module__1xzv-W__brandList",
  "brandListMain": "brands-module-scss-module__1xzv-W__brandListMain",
  "brandName": "brands-module-scss-module__1xzv-W__brandName",
  "brandTitle": "brands-module-scss-module__1xzv-W__brandTitle",
  "messageBox": "brands-module-scss-module__1xzv-W__messageBox",
  "sidebar": "brands-module-scss-module__1xzv-W__sidebar",
});
